import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found-container d-flex flex-column justify-content-center align-items-center vh-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "display-1 fw-bold text-primary" }, "404", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-muted" }, "Oops! Page not found.", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-center text-secondary" }, " The page you're looking for doesn't exist or has been moved. ", -1)),
    _createVNode(_component_router_link, {
      to: "/",
      class: "btn btn-primary mt-3"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Go Home")
      ])),
      _: 1
    })
  ]))
}